import {
  BASE_PROJECT_DEVELOPMENT_CONFIG,
  PRELIMINARY_DESIGN,
  ProjectDevelopmentStructure,
  ProjectTypeStructure,
  WORKING_DOCUMENTATION,
} from '../../../components';
import {
  ENGINEERING_SYSTEMS_CDN_PATH,
  ENGINEERING_SYSTEMS_STORAGE_PATH,
} from '../../../engineering-systems-constants';
import {
  POWER_SUPPLY_PRELIMINARY_DESIGN_ID,
  POWER_SUPPLY_WORKING_DOCUMENTATION_ID,
} from '../../power-supply-systems-constants';

export const POWER_SUPPLY_PROJECT_TYPE_LIST: ProjectTypeStructure[] = [
  {
    ...PRELIMINARY_DESIGN,
    id: POWER_SUPPLY_PRELIMINARY_DESIGN_ID,
    compositionList: [
      '— техническое задание (заполняется заказчиком);',
      '— однолинейная схема электрического щита;',
      '— план размещения оконечных устройств;',
      '— спецификация товаров;',
      '— смета на монтажные работы.',
    ],
    schedule: '5 – 20 рабочих дней',
    consultationSignup: {
      href: `${ENGINEERING_SYSTEMS_STORAGE_PATH}sistemy-elektrosnabzheniya-primer-eskiznogo-proekta.pdf`,
      src: `${ENGINEERING_SYSTEMS_CDN_PATH}/features/1.svg/1.svg`,
      label: 'Скачать пример',
    },
  },
  {
    ...WORKING_DOCUMENTATION,
    typeInfo: {
      ...WORKING_DOCUMENTATION.typeInfo,
      description:
        'Проектная документация содержит всю техническую информацию, аксонометрические схемы и\u00A0трассировки кабельных линий. Позволяет разработать техническое решение, подобрать оборудование и\u00A0рассчитать стоимость всего проекта.',
    },
    id: POWER_SUPPLY_WORKING_DOCUMENTATION_ID,
    priceUnits: '/м²',
    compositionList: [
      '— все части услуги эскизного проекта;',
      '— пояснительная записка;',
      '— однолинейные схемы;',
      '— трассировки кабельных линий;',
    ],
    schedule: '5 – 20 рабочих дней',
    consultationSignup: {
      href: `${ENGINEERING_SYSTEMS_STORAGE_PATH}sistemy-elektrosnabzheniya-primer-rabochey-dokumentacii.pdf`,
      src: `${ENGINEERING_SYSTEMS_CDN_PATH}/heating/2.svg/2.svg`,
      label: 'Скачать пример',
    },
  },
];

export const POWER_SUPPLY_DEVELOPMENT: ProjectDevelopmentStructure = {
  ...BASE_PROJECT_DEVELOPMENT_CONFIG,
  description:
    'Проектная документация содержит всю техническую информацию, аксонометрические схемы и\u00A0трассировки кабельных линий. Позволяет разработать техническое решение, подобрать оборудование и\u00A0рассчитать стоимость всего проекта. Монтаж и\u00A0оборудование оплачиваются отдельно, согласно проектной смете.',
  id: POWER_SUPPLY_WORKING_DOCUMENTATION_ID,
  compositionList: [
    '— все части услуги эскизного проекта;',
    '— пояснительная записка;',
    '— однолинейные схемы;',
    '— трассировки кабельных линий.',
  ],
  exampleHref: `${ENGINEERING_SYSTEMS_STORAGE_PATH}sistemy-elektrosnabzheniya-primer-rabochey-dokumentacii.pdf`,
  priceUnits: '/м²',
  schedule: '5 – 20 рабочих дней',
};
